"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require("components");

var _utils = require("utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutSummaryBox = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(CheckoutSummaryBox, _React$Component);

  function CheckoutSummaryBox() {
    (0, _classCallCheck3.default)(this, CheckoutSummaryBox);
    return (0, _possibleConstructorReturn3.default)(this, (CheckoutSummaryBox.__proto__ || (0, _getPrototypeOf2.default)(CheckoutSummaryBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(CheckoutSummaryBox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var styles = require("./CheckoutSummaryBox.scss");

      var el = void 0;
      if (prevProps.vatAmount != this.props.vatAmount) {
        console.log("updating vat amount");
        el = _reactDom2.default.findDOMNode(this.refs.vatAmount);
        el.classList.remove(styles.Blink);
        void el.offsetWidth;
        el.classList.add(styles.Blink);
      }

      if (prevProps.price != this.props.price) {
        console.log("updating price");
        el = _reactDom2.default.findDOMNode(this.refs.price);
        el.classList.remove(styles.Blink);
        void el.offsetWidth;
        el.classList.add(styles.Blink);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var styles = require("./CheckoutSummaryBox.scss");
      var c = (0, _utils.mapAndJoinStyles)(styles);

      var _props = this.props,
          name = _props.name,
          description = _props.description,
          price = _props.price,
          rate = _props.rate,
          priceDescription = _props.priceDescription,
          loading = _props.loading,
          priceExcludingTax = _props.priceExcludingTax,
          vatAmount = _props.vatAmount;


      var reverseCharged = price == priceExcludingTax && rate !== 0;

      return _react2.default.createElement(
        "section",
        { className: c("CheckoutSummaryBox") },
        _react2.default.createElement(
          "div",
          { className: c("LineItem") },
          _react2.default.createElement(
            "div",
            { className: c("LineItem__info") },
            _react2.default.createElement(
              "h1",
              { className: c("LineItem__title") },
              name
            ),
            _react2.default.createElement(
              "span",
              { className: c("LineItem__description") },
              description
            )
          ),
          _react2.default.createElement(
            "div",
            { className: c("LineItem__price") },
            _react2.default.createElement(
              "span",
              { className: c("LineItem__amount") },
              (0, _utils.prettyDollars)(priceExcludingTax || price)
            ),
            _react2.default.createElement(
              "span",
              { className: c("LineItem__amountDescription") },
              priceDescription
            )
          )
        ),
        _react2.default.createElement(
          "table",
          { className: c("Totals") },
          _react2.default.createElement(
            "tbody",
            null,
            _react2.default.createElement(
              "tr",
              { className: c("Totals__subTotal") },
              _react2.default.createElement(
                "td",
                { className: c("Totals__label") },
                "Subtotal"
              ),
              _react2.default.createElement(
                "td",
                { className: c("Totals__value") },
                (0, _utils.prettyDollars)(priceExcludingTax || price, true)
              )
            ),
            _react2.default.createElement(
              "tr",
              { className: c("Totals__taxes") },
              _react2.default.createElement(
                "td",
                { className: c("Totals__label") },
                "Taxes"
              ),
              _react2.default.createElement(
                "td",
                { className: c("Totals__value") },
                _react2.default.createElement(
                  "span",
                  { ref: "vatAmount" },
                  reverseCharged ? "Reverse charged" : (0, _utils.prettyDollars)(vatAmount, true)
                )
              )
            ),
            _react2.default.createElement(
              "tr",
              { className: c("Totals__total") },
              _react2.default.createElement(
                "td",
                { className: c("Totals__label") },
                "Total"
              ),
              _react2.default.createElement(
                "td",
                { className: c("Totals__value") },
                _react2.default.createElement(
                  "span",
                  { ref: "price" },
                  (0, _utils.prettyDollars)(price, true)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CheckoutSummaryBox;
}(_react2.default.Component), _class.defaultProps = {
  vatAmount: 0
}, _temp);
exports.default = CheckoutSummaryBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckoutSummaryBox/CheckoutSummaryBox.jsx
// module id = 2436
// module chunks = 0